import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';
import { companyInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { label: 'Auditoria Independente', path: '/servicos#auditoria-independente' },
    { label: 'Consultoria Tributária', path: '/servicos#consultoria-tributaria' },
    { label: 'Governança e Compliance', path: '/servicos#governanca-risco-compliance' },
    { label: 'BPO / Terceirização', path: '/servicos#terceirizacao-bpo' },
    { label: 'eSocial e Trabalhista', path: '/servicos#trabalhista-previdenciario' }
  ];

  const institutionalLinks = [
    { label: 'Sobre a eLauria', path: '/sobre' },
    { label: 'Trabalhe Conosco', path: '/trabalhe-conosco' },
    { label: 'Contato', path: '/contato' },
    { label: 'Política de Privacidade', path: '/privacidade' }
  ];

  return (
    <footer className="footer py-12">
      <div className="container-main">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 pb-10 border-b border-[#E2E8F0]">
          {/* Company Info */}
          <div>
            <img 
              src={companyInfo.logo} 
              alt={companyInfo.name} 
              className="h-7 mb-4"
            />
            <p className="text-[#64748B] text-xs mb-2">
              {companyInfo.tagline}
            </p>
            <p className="text-[#94A3B8] text-xs">
              Desde {companyInfo.foundedYear}
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#0F172A] font-semibold text-xs uppercase tracking-wider mb-4">Serviços</h4>
            <ul className="space-y-2">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-[#64748B] hover:text-[#3E6B2A] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Institutional */}
          <div>
            <h4 className="text-[#0F172A] font-semibold text-xs uppercase tracking-wider mb-4">Institucional</h4>
            <ul className="space-y-2">
              {institutionalLinks.map((link, index) => (
                <li key={index}>
                  <Link 
                    to={link.path} 
                    className="text-[#64748B] hover:text-[#3E6B2A] transition-colors text-sm"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#0F172A] font-semibold text-xs uppercase tracking-wider mb-4">Contato</h4>
            <ul className="space-y-3">
              <li>
                <a 
                  href={`https://maps.google.com/?q=${encodeURIComponent(companyInfo.location.address + ', ' + companyInfo.location.city)}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2 text-[#64748B] hover:text-[#3E6B2A] transition-colors"
                >
                  <MapPin size={14} className="text-[#3E6B2A] mt-0.5 flex-shrink-0" />
                  <span className="text-xs leading-relaxed">
                    {companyInfo.location.address}<br />
                    {companyInfo.location.city}-{companyInfo.location.state}
                  </span>
                </a>
              </li>
              <li>
                <a 
                  href={`https://wa.me/${companyInfo.contact.whatsapp}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-[#64748B] hover:text-[#3E6B2A] transition-colors"
                >
                  <Phone size={14} className="text-[#3E6B2A] flex-shrink-0" />
                  <span className="text-xs">{companyInfo.contact.phone}</span>
                </a>
              </li>
              <li>
                <a 
                  href={`mailto:${companyInfo.contact.email}`}
                  className="flex items-center gap-2 text-[#64748B] hover:text-[#3E6B2A] transition-colors"
                >
                  <Mail size={14} className="text-[#3E6B2A] flex-shrink-0" />
                  <span className="text-xs">{companyInfo.contact.email}</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Footer */}
        <div className="pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-[#94A3B8] text-xs">
            © {currentYear} {companyInfo.name}. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-3 text-[#94A3B8] text-xs">
            <Link to="/privacidade" className="hover:text-[#3E6B2A] transition-colors">
              Privacidade
            </Link>
            <span>•</span>
            <span>{companyInfo.contact.website}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
